import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import type { PhoneNumberSummary } from "@/types/assistants/assistants";
import { requestData } from "@/api/api-config";
export const faxPhoneNumbersQueryKeys = {
  all: ["fax", "phone-numbers"] as const,
  fax: () => [...faxPhoneNumbersQueryKeys.all, "fax-lines"] as const
};

/**
 * Fax lines for the compose form's "From" dropdown.
 *
 * Hits the fax-permissioned `GET /faxes/phone-numbers` endpoint rather than the
 * settings `GET /admin/phone-numbers?type=FAX` one, which is gated by
 * AI-assistant read — a fax-only user 403s there and the form wrongly reports
 * "No fax line configured." Passes `catchError = false` (the 4th positional arg,
 * matching the sibling phone-number fetchers) so HTTP errors propagate as
 * exceptions to React Query (`isError`) instead of being swallowed into a toast;
 * `null` is only returned for a genuinely empty response.
 */
export async function fetchFaxLines(): Promise<PhoneNumberSummary[] | null> {
  return await requestData<PhoneNumberSummary[]>("faxes/phone-numbers", "get", {}, false);
}
export function useFaxPhoneNumbers() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      queryKey: faxPhoneNumbersQueryKeys.fax(),
      queryFn: _temp
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useQuery(t0);
}
function _temp() {
  return fetchFaxLines();
}